export default __webpack_public_path__ + "static/media/iad.a60b601a.mp3";